import { createContext, useContext } from "react";
import { MapCanvasShapesState } from "./MapCanvasContext.types";

export const MapCanvasShapesContext =
  createContext<MapCanvasShapesState | null>(null);

export const useMapCanvasShapes = () => {
  const context = useContext(MapCanvasShapesContext);
  if (!context) {
    throw new Error(
      "useMapCanvasShapes must be used within a MapCanvasProvider"
    );
  }
  return context;
};
